import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const fetchViCtsListViewData = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.VI_CTS}/fetchList`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error inside fetchViCtsListViewData : ", err);
    return err;
  }
};

export const fetchViCtsTransferSettingHistory = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.VI_CTS}/fetchTransferSettingHistory`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error inside fetchViCtsTransferSettingList : ", err);
    return err;
  }
};

export const setTransferRate = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.VI_CTS}/setTransferRate`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error inside setTransferRate : ", err);
    return err;
  }
}

export const getPromotionalContactBatch = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.VI_CTS}/getPromotionalNumbers`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error inside getPromotionalContactBatch : ", err);
    return err?.response?.data || err;
  }
}


export const initiateFileDownload = async (payload) => {
  try {
    const token = getToken();
    const response = await apiService.post(
      `${API_URL.VI_CTS}/initiateFileDownload`,
      payload,
      token,
    );
    return response;
  } catch (err) {
    console.log("Error inside initiateFileDownload : ", err);
    return err?.response?.data || err;
  }
}
